import {
  getSiteLocations,
  createSiteLocation,
  updateSiteLocation,
} from '../../../../lib/site-metadata';
import { SiteManagedListSection } from './SiteManagedListSection';

interface Props {
  companyId: string;
  siteId: string;
  isOwner: boolean;
}

const locationIcon = (
  <svg className="mx-auto h-8 w-8 text-ink-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

export function SiteLocationsSection({ companyId, siteId, isOwner }: Props) {
  return (
    <SiteManagedListSection
      companyId={companyId}
      siteId={siteId}
      isOwner={isOwner}
      title="장소"
      description="현장 내 장소(구역) 목록. 사진 촬영 위치 지정에 사용됩니다."
      queryKey="site-locations"
      emptyText="등록된 장소가 없습니다."
      emptyAddText="장소 추가하기"
      fieldLabel="장소명"
      fieldPlaceholder="예: 공장A, 창고동, 사무동"
      modalAddTitle="새 장소 추가"
      modalEditTitle="장소 수정"
      deactivateTitle="장소 비활성화"
      deactivateDescription={(name) => (
        <>
          <strong>{name}</strong> 장소를 비활성화하시겠습니까?
          <br />
          기존 사진 데이터는 유지되며, 새 점검에서 선택할 수 없게 됩니다.
        </>
      )}
      emptyIcon={locationIcon}
      fetchItems={getSiteLocations}
      createItem={createSiteLocation}
      updateItem={updateSiteLocation}
    />
  );
}
